import {Component, EventEmitter, inject, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {environment} from "projects/store/src/environments/environment";
import {PixelService} from "projects/store/src/app/services/api/v1/pixel.service";
import {LocalStorageService, UtilService} from "library";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';

enum Steps {
  logo = 'logo',
  '5steps' = '5steps',
}
@Component({
  selector: 'app-sales-gateway',
  templateUrl: './sales-gateway.component.html',
})
export class SalesGatewayComponent implements OnInit {

  step = Steps["5steps"];
  @Output() nextStepEvent = new EventEmitter();
  country = environment.global.country;
  flowCode: string;

  private readonly metaPixelService = inject(PixelService);
  private utilService = inject(UtilService);
  private route = inject(ActivatedRoute);
  private localStorageService = inject(LocalStorageService);
  public macroFlowService = inject(MacroFlowService);

  constructor() {
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.utilService.disablePageLoading();
  }

  ngOnInit() {

  }

  onNextStep() {
    this.captureAndSaveUtmParams();
    this.metaPixelService.trackEvent('CustomizeProduct');
    this.nextStepEvent.emit();
  }

  private captureAndSaveUtmParams(): void {
    const queryParams = this.route.snapshot.queryParams;

    const utmData: any = {};
    let hasParams = false;

    // Capturar todos los parámetros excepto start_token
    Object.keys(queryParams).forEach(key => {
      if (key !== 'start_token') {
        utmData[key] = queryParams[key];
        hasParams = true;
      }
    });

    if (hasParams) {
      this.localStorageService.set(LocalStorageKey.utmData, utmData);
    }
  }

  protected readonly Steps = Steps;
}
